import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export type TagVariant = 'brand' | 'neutral' | 'success' | 'warning' | 'error' | 'info';

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: TagVariant;
  children: ReactNode;
}

const variantStyles: Record<TagVariant, string> = {
  brand: 'bg-brand-50 text-brand-700 border-brand-100',
  neutral: 'bg-neutral-100 text-neutral-700 border-neutral-200',
  success: 'bg-success-100 text-success-600 border-success-100',
  warning: 'bg-warning-100 text-warning-600 border-warning-100',
  error: 'bg-error-100 text-error-600 border-error-100',
  info: 'bg-info-100 text-info-600 border-info-100',
};

export function Tag({ variant = 'brand', children, className, ...rest }: TagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2.5 py-0.5 text-xs font-medium',
        'rounded-pill border font-mono tracking-wide',
        variantStyles[variant],
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
